import { tv } from "tailwind-variants"
import {
  type AvatarBadgeSize,
  avatarBadgeVariants,
} from "../Avatar/avatar-badge"

export type LockupSize = "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl"

type LockupSizeValues = {
  image: number
  badge?: AvatarBadgeSize
}

export const LOCKUP_SIZES: Record<LockupSize, LockupSizeValues> = {
  xs: {
    image: 20,
  },
  sm: {
    image: 24,
  },
  md: {
    image: 32,
    badge: "xs",
  },
  lg: {
    image: 40,
    badge: "sm",
  },
  xl: {
    image: 48,
    badge: "md",
  },
  "2xl": {
    image: 56,
    badge: "md",
  },
  "3xl": {
    image: 64,
    badge: "md",
  },
}

export const lockupSizeVariants = tv({
  slots: {
    base: "",
    image: "rounded",
    text: "",
    badge: "",
    verifiedIcon: "shrink-0",
  },
  variants: {
    size: {
      xs: {
        base: "h-6 text-xs",
        image: "min-h-5 min-w-5",
        text: "text-xs",
        badge: avatarBadgeVariants({ size: "xs" }),
        verifiedIcon: "size-3.5",
      },
      sm: {
        base: "h-8 text-sm",
        image: "min-h-6 min-w-6",
        text: "text-sm",
        badge: avatarBadgeVariants({ size: "sm" }),
        verifiedIcon: "size-3.5",
      },
      md: {
        base: "h-12 text-sm",
        image: "min-h-8 min-w-8",
        text: "text-sm",
        badge: avatarBadgeVariants({ size: "xs" }),
        verifiedIcon: "size-3.5",
      },
      lg: {
        base: "h-[60px] text-sm",
        image: "min-h-10 min-w-10",
        text: "text-sm",
        badge: avatarBadgeVariants({ size: "sm" }),
        verifiedIcon: "size-4",
      },
      xl: {
        base: "h-[68px] text-md",
        image: "min-h-12 min-w-12",
        text: "text-md",
        badge: avatarBadgeVariants({ size: "md" }),
        verifiedIcon: "size-4",
      },
      "2xl": {
        base: "h-[76px] text-heading-sm",
        image: "min-h-14 min-w-14",
        text: "text-heading-sm",
        badge: avatarBadgeVariants({ size: "md" }),
        verifiedIcon: "size-4",
      },
      "3xl": {
        base: "h-[84px] text-heading-lg",
        image: "min-h-16 min-w-16",
        text: "text-heading-lg",
        badge: avatarBadgeVariants({ size: "md" }),
        verifiedIcon: "size-6",
      },
    },
  },
})
